import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=51612825"
import script from "./richText.vue?vue&type=script&lang=js"
export * from "./richText.vue?vue&type=script&lang=js"
import style0 from "./richText.vue?vue&type=style&index=0&id=51612825&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports